/// <reference path="index.d.ts" />

import axios from "@r/axios";
import React, { useEffect, useRef, useState } from "react";
import { Range } from "react-range";
import { useAsyncFn, useDebounce, useUpdateEffect } from "react-use";

// interface Filter {
// 	page: number;
// 	types: any[];
// 	purposes: any[];
// 	numeric: any[];
// 	symbolic: any[];
// 	query_s: string;
// }

// interface CatalogItems {
// 	data: any[];
// 	last_page: number;
// 	current_page: number;
// }

const UICheckbox = ({ item, parent = false, onChange = null }) => {
    const [checked, setChecked] = useState(item.checked);

    useEffect(() => {
        if (item.checked == checked) return;

        item.checked = checked;

        if (parent) {
            item.children.forEach((ic) => {
                ic.checked = checked;
            });
        }

        onChange(checked, item);
    }, [checked]);

    return (
        <div
            className="form-check cursor-pointer"
            onClick={() => setChecked(!checked)}
        >
            <input
                className="form-check-input"
                type="checkbox"
                checked={item.checked}
                onChange={() => {}}
            />
            <label
                className={
                    "form-check-label base-text " +
                    (parent ? "fw-bold" : "cursor-pointer")
                }
            >
                {item.title}
            </label>
        </div>
    );
};

const TypesFilter = ({ types, updateFilter }) => {
    return (
        <div className="py-3">
            <div className="base-text fw-bold">Тип решения</div>
            <div className="p-3">
                <div className="pe-2 pad-b-5">
                    {types.map((i) => {
                        return (
                            <div className="mar-b-5" key={`ti-${i.id}`}>
                                <UICheckbox
                                    item={i}
                                    onChange={() => updateFilter()}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

const PurposesFilter = ({ filter, updateFilter }) => {
    return (
        <div className="old-filter-section">
            <div className="base-text fw-bold">Назначение использования</div>
            <div className="p-3">
                <div className="pe-2 pad-b-5">
                    {filter.purposes.map((i) => {
                        return (
                            <div className="mar-b-5" key={`pi-${i.id}`}>
                                <div className="mar-b-5">
                                    <UICheckbox
                                        item={i}
                                        parent={true}
                                        onChange={() => updateFilter()}
                                    />
                                </div>
                                <div className="sub-item">
                                    <div className="pe-2 pad-b-5">
                                        {i.children.map((ic) => (
                                            <div
                                                className="mar-b-5 ms-3"
                                                key={`pic-${ic.id}`}
                                            >
                                                <UICheckbox
                                                    item={ic}
                                                    onChange={() =>
                                                        updateFilter()
                                                    }
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

const NumericSlider = ({ item, updateFilter }) => {
    const [values, setValues] = useState([item.from, item.to]);
    const [from, setFrom] = useState(item.from);
    const [to, setTo] = useState(item.to);

    const timeoutRef = useRef(null);

    const onChangeValue = (values) => {
        setValues(values);
        item.from = parseFloat(values[0] || 0);
        item.to = parseFloat(values[1] || 0);
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => updateFilter(), 1000);
    };

    useEffect(() => {
        setValues([item.from, item.to]);
    }, [item.from, item.to]);

    return (
        <div className="old-filter-section">
            <div className="filter-section__top">
                <div className="js-toggle-btn filter-title">
                    <span className="filter-title__main">{`${item.title} ${item.unit}`}</span>
                </div>
            </div>
            <div className="filter-section_content text-center">
                <Range
                    min={from}
                    max={to}
                    values={values}
                    onChange={onChangeValue}
                    renderTrack={({ props, children }) => (
                        <div
                            {...props}
                            style={{
                                ...props.style,
                                height: "6px",
                                width: "100%",
                                backgroundColor: "#ccc",
                            }}
                        >
                            {children}
                        </div>
                    )}
                    renderThumb={({ props, index }) => (
                        <div
                            {...props}
                            style={{
                                ...props.style,
                                height: "14px",
                                width: "14px",
                                borderRadius: "100%",
                                backgroundColor: "#333",
                            }}
                        />
                    )}
                />
                <div
                    style={{
                        marginTop: "10px",
                        color: "#333",
                        fontWeight: "bold",
                        fontSize: "14px",
                        padding: "4px",
                    }}
                >
                    {values[0].toFixed(0)} - {values[1].toFixed(0)}
                </div>
            </div>
        </div>
    );
};

const NumericFilter = ({ filter, updateFilter }) => {
    return filter.numeric.map((item) => (
        <NumericSlider
            item={item}
            key={`in-${item.id}`}
            updateFilter={() => updateFilter()}
        />
    ));
};

const SymbolicFilter = ({ filter, updateFilter }) => {
    return filter.symbolic.map((item) => (
        <div key={`is-${item.id}`} className="old-filter-section">
            <div className="filter-section__top">
                <div className="filter-title">
                    <svg className="icon">
                        <use xlinkHref="/images/sprite.svg#expand-top"></use>
                    </svg>
                    <span className="filter-title__main">{item.title}</span>
                </div>
            </div>
            <div className="filter-section_content">
                <div className="filter-list-row">
                    <div className="pe-2 pad-b-5">
                        {item.values.map((ic) => {
                            return (
                                <div className="mar-b-5" key={`isc-${ic.id}`}>
                                    <UICheckbox
                                        item={ic}
                                        onChange={() => updateFilter()}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    ));
};

const FilterComponent = ({ filter, updateFilter }) => {
    return (
        <>
            {filter.types.length > 0 && (
                <TypesFilter
                    types={filter.types}
                    updateFilter={() => updateFilter()}
                />
            )}
            {filter.purposes.length > 0 && (
                <PurposesFilter
                    filter={filter}
                    updateFilter={() => updateFilter()}
                />
            )}
            <NumericFilter
                filter={filter}
                updateFilter={() => updateFilter()}
            />
            <SymbolicFilter
                filter={filter}
                updateFilter={() => updateFilter()}
            />
        </>
    );
};

const CardAddInfo = ({ item, onClose }) => {
    const initState = {
        materials: { items: [], price: 0 },
        services: { items: [], price: 0 },
        deliveries: 0,
    };

    const scrolRef = useRef();

    const [state, setState] = useState(initState);

    const handleClose = () => {
        onClose();
        setState(initState);
    };

    const PriceContainer = ({ price }) => {
        price = price.format(2, 3, " ", ".").split(".");
        return (
            <div className="card-item-popup__content-price card-price_underline">
                от<span className="price-block__price">{price[0]}</span>руб/м
                <sup>2</sup>
            </div>
        );
    };

    useEffect(() => {
        (async () => {
            const { data, status } = await axios.post(
                `/systems/${item.slug}/what-include`,
                { region }
            );
            setState((state) => ({ ...state, ...data }));
        })();
    }, [item]);

    useEffect(() => {
        if (typeof $ === undefined) return;
        $(scrolRef.current).mCustomScrollbar();
    }, [scrolRef]);

    return (
        <div className="card-item-popup react">
            <div
                className="card-item-popup__cross"
                onClick={() => handleClose()}
            >
                <svg className="icon">
                    <use xlinkHref="/images/sprite.svg#popup-cross"></use>
                </svg>
            </div>
            <div className="popup-content-wrapper" ref={scrolRef}>
                <div className="popup-padding">
                    <div className="card-item-popup__title first">
                        Что входит в стоимость
                    </div>
                    <div className="card-item-popup__content">
                        <div className="card-item-popup__content-wrap">
                            <div className="card-item-popup__content-title">
                                Доставка:
                            </div>
                            <PriceContainer price={state.deliveries} />
                        </div>
                        <div className="card-item-popup__content-wrap">
                            <div className="card-item-popup__content-title">
                                Материалы:
                            </div>
                            <PriceContainer price={state.materials.price} />
                        </div>
                        <ul className="card-item-popup__content-list">
                            {state.materials.items.map((i, j) => (
                                <li
                                    key={`mk-${j}`}
                                    className="card-item-popup__list-item"
                                >
                                    <a>{i.title}</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="card-item-popup__title">
                        Не входит в стоимость
                    </div>
                    <div className="card-item-popup__content">
                        <div className="card-item-popup__content-wrap">
                            <div className="card-item-popup__content-title">
                                Услуги:
                            </div>
                            <PriceContainer price={state.services.price} />
                        </div>
                        <ul className="card-item-popup__content-list">
                            {state.services.items.map((i, j) => (
                                <li
                                    key={`sk-${j}`}
                                    className="card-item-popup__list-item"
                                >
                                    <a>{i.title}</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

const CardProperty = ({ property }) => {
    if (property.type === "numeric")
        return (
            <div className="small-text mar-b-4">
                <div className="row">
                    <div className="col-5 small-text text-start">
                        {property.title}
                    </div>
                    <div className="col-7 small-text text-end fw-bold">
                        {property.from &&
                            ((property.to && (
                                <span>{`от ${property.from} `}</span>
                            )) || <span>{`${property.from} `}</span>)}
                        {property.to && <span>{`до ${property.to} `}</span>}
                        {property.unit && <span>{property.unit}</span>}
                    </div>
                </div>
            </div>
        );
    return (
        <div className="small-text mar-b-4">
            <div className="row">
                <div className="col-5 small-text text-start">
                    {property.title}
                </div>
                <div className="col-7 small-text text-end fw-bold">
                    {property.value}
                </div>
            </div>
        </div>
    );
};

const CardProperties = ({ properties }) => {
    return properties.map((x, i) => (
        <CardProperty key={`prop-card-${i}`} property={x} />
    ));
};

const PricePlacemet = ({ price }) => {
    price = price.split(".");
    return (
        <div
            className="price-block-mini mar-b-1"
            itemType="http://schema.org/Offer"
            itemProp="offers"
            itemScope=""
        >
            от
            <span className="price-block__price">
                {price[0]}
                <sup>.{price[1]}</sup>
            </span>
            руб/м<sup>2</sup>
            <meta itemProp="price" content={price[0] + "." + price[1]} />
            <meta itemProp="priceCurrency" content="RUB" />
            <link itemProp="availability" href="http://schema.org/InStock" />
        </div>
    );
};

const CardItem = ({ item, onClick, cardItemLinksDisabled }) => {
    const [showAddons, setAddons] = useState(false);

    const clickByLink = (e) => {
        if (onClick) {
            onClick();
            e.preventDefault();
            return false;
        }
    };

    return (
        <div className="col-12 col-xs-12 col-sm-6 col-lg-6 col-xl-4">
            <div
                className="fl-card"
                itemType="http://schema.org/Product"
                itemProp="itemListElement"
                itemScope=""
            >
                {showAddons && (
                    <CardAddInfo item={item} onClose={() => setAddons(false)} />
                )}
                <div className="fl-card-img">
                    {cardItemLinksDisabled ? (
                        <div
                            style={{ cursor: "pointer" }}
                            onClick={(e) => clickByLink(e)}
                        >
                            <img
                                className="js-img"
                                data-src={item.thumb.url}
                                src={item.thumb.url}
                                alt=""
                            />
                        </div>
                    ) : (
                        <a href={item.link} onClick={(e) => clickByLink(e)}>
                            <img
                                className="js-img"
                                data-src={item.thumb.url}
                                src={item.thumb.url}
                                alt=""
                            />
                        </a>
                    )}
                    <meta itemProp="image" content={item.thumb.url} />
                </div>
                <div className="fl-card-content">
                    <div className="fl-card-content-header" itemProp="name">
                        {cardItemLinksDisabled ? (
                            <div
                                style={{ cursor: "pointer" }}
                                className="btn-link-gray large-text fw-bold mar-b-4"
                                onClick={(e) => clickByLink(e)}
                                itemProp="url"
                            >
                                {item.title}
                            </div>
                        ) : (
                            <a
                                className="btn-link-gray large-text fw-bold mar-b-4"
                                href={item.link}
                                onClick={(e) => clickByLink(e)}
                                itemProp="url"
                            >
                                {item.title}
                            </a>
                        )}
                    </div>
                    <div className="card-top-bar">
                        <PricePlacemet price={item.price} />
                        <a
                            className="link-icon"
                            onClick={() => setAddons(true)}
                        >
                            <svg className="icon">
                                <use xlinkHref="/images/sprite.svg#info"></use>
                            </svg>
                            <span className="link-icon__text card-popup-open-js">
                                Что входит
                            </span>
                        </a>
                    </div>
                    {item.properties && (
                        <CardProperties properties={item.properties} />
                    )}
                </div>
            </div>
        </div>
    );
};

const CatalogToolBar = ({ filter, text, setText }) => {
    const [isMobileSearchMode, setIsMobileSearchMode] = useState(false);

    const handleSearchBtnClick = () => {
        setIsMobileSearchMode((prevValue) => {
            return !prevValue;
        });
    };

    return (
        <div
            className={[
                "catalog-top-bar",
                isMobileSearchMode ? "catalog-top-bar--mobile-search-mode" : "",
            ].join(" ")}
        >
            <div
                className="btn btn-light catalog-filter-btn d-lg-none"
                data-bs-toggle="offcanvas"
                data-bs-target="#catalog-filter"
            >
                <svg className="icon settings-icon">
                    <use xlinkHref="/images/sprite.svg#settings-icon"></use>
                </svg>
                <span>Фильтр</span>
            </div>
            <div className="filter-popup js--filter-popup">
                <div className="filter-popup__wrap">
                    <div className="filter-popup__cross">
                        <svg className="icon">
                            <use xlinkHref="/images/sprite.svg#cross"></use>
                        </svg>
                    </div>
                    <div className="filter-popup__content">
                        <div className="filter-popup__title">
                            Сортировать по:
                        </div>
                        <form
                            className="filter-popup__form"
                            action="#"
                            method="get"
                        >
                            <select className="js-styled filter-popup__select">
                                <option className="filter-up">Цене</option>
                                <option className="filter-down">Цене</option>
                                <option className="filter-a">Названию</option>
                                <option className="filter-z">Названию</option>
                            </select>
                            <div className="catalog-side"></div>
                            <div className="list-radio__btns">
                                <button className="list-radio__btn-back">
                                    Сбросить
                                </button>
                                <button
                                    className="list-radio__btn-submit"
                                    type="submit"
                                >
                                    Применить
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {!filter.is_tag && (
                <div className="calculator-search">
                    <input
                        type="text"
                        placeholder="Поиск по названию"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                    />
                    <svg className="icon search__icon">
                        <use xlinkHref="/images/sprite.svg#loop"></use>
                    </svg>
                </div>
            )}
            <button
                className="catalog-top-bar__btn-search"
                onClick={handleSearchBtnClick}
            >
                <svg className="icon">
                    <use xlinkHref="/images/sprite.svg#loop"></use>
                </svg>
            </button>
        </div>
    );
};

const CatalogContent = ({
    items,
    itemSelected,
    cardItemLinksDisabled,
    isLoading,
}) => {
    return (
        <div
            className={[
                "row g-6 catalog",
                isLoading ? "catalog--loading" : "",
            ].join(" ")}
            itemType="http://schema.org/ItemList"
            itemScope=""
        >
            {items.map((i) => (
                <CardItem
                    key={`si-${i.id}`}
                    item={i}
                    onClick={() => itemSelected(i)}
                    cardItemLinksDisabled={cardItemLinksDisabled}
                />
            ))}
        </div>
    );
};

const Paginator = ({ page, setPage }) => {
    const pages = [];

    for (var i = 1; i <= page.last_page; i++) {
        let index = i;
        let active = page.current_page === index;
        pages.push(
            <li
                className={
                    active ? "paging-list__item active" : "paging-list__item"
                }
                key={`pg-lk-${i}`}
                onClick={() => setPage(index)}
            >
                <a className="paging-list__link">{i}</a>
            </li>
        );
    }

    const PrevBtn = () => {
        return (
            <li>
                <a
                    className="btn-slider"
                    onClick={() => setPage(page.current_page - 1)}
                >
                    <svg className="icon">
                        <use xlinkHref="/images/sprite.svg#arrow-left"></use>
                    </svg>
                </a>
            </li>
        );
    };

    const NextBtn = () => {
        return (
            <li>
                <a
                    className="btn-slider"
                    onClick={() => setPage(page.current_page + 1)}
                >
                    <svg className="icon">
                        <use xlinkHref="/images/sprite.svg#arrow-right"></use>
                    </svg>
                </a>
            </li>
        );
    };

    return (
        <ul className="paging-list">
            {page.current_page > 1 && <PrevBtn />}
            {pages}
            {page.current_page !== page.last_page && <NextBtn />}
        </ul>
    );
};

const FilterTags = ({ filter, updateFilter }) => {
    const removeType = (item) => {
        item.checked = false;
        updateFilter();
    };

    const removePurpose = (item) => {
        item.checked = false;
        updateFilter();
    };

    const removeNumeric = (item) => {
        item.from = item.values[0];
        item.to = item.values[item.values.length - 1];
        updateFilter();
    };

    const removeSymbolic = (item) => {
        item.values.forEach((value) => {
            value.checked = false;
        });
        updateFilter();
    };

    return (
        <div className="filter-tags">
            {filter.types.map(
                (x) =>
                    x.checked && (
                        <div className="filter-tags__item" key={`type-${x.id}`}>
                            <span>Тип: {x.title}</span>
                            <a
                                href="#"
                                className="close"
                                onClick={(e) => {
                                    e.preventDefault();
                                    removeType(x);
                                }}
                            />
                        </div>
                    )
            )}
            {filter.purposes.map((x) =>
                x.children.map(
                    (x) =>
                        x.checked && (
                            <div
                                className="filter-tags__item"
                                key={`child-${x.id}`}
                            >
                                <span>Назначение: {x.title}</span>
                                <a
                                    href="#"
                                    className="close"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        removePurpose(x);
                                    }}
                                />
                            </div>
                        )
                )
            )}
            {filter.numeric.map((x) => {
                if (
                    x.from !== x.values[0] ||
                    x.to !== x.values[x.values.length - 1]
                )
                    return (
                        <div className="filter-tags__item" key={`num-${x.id}`}>
                            <span>
                                {x.title}: {x.from && `от ${x.from}`}{" "}
                                {x.to && `до ${x.to}`} {x.unit}
                            </span>
                            <a
                                href="#"
                                className="close"
                                onClick={(e) => {
                                    e.preventDefault();
                                    removeNumeric(x);
                                }}
                            />
                        </div>
                    );
            })}
            {filter.symbolic.map((x) => {
                const values = x.values.filter((x) => x.checked);
                if (values.length > 0)
                    return (
                        <div className="filter-tags__item" key={`sym-${x.id}`}>
                            <span>
                                {x.title}: {values.map((x) => x.title + " ")}
                            </span>
                            <a
                                href="#"
                                className="close"
                                onClick={(e) => {
                                    e.preventDefault();
                                    removeSymbolic(x);
                                }}
                            />
                        </div>
                    );
            })}
        </div>
    );
};

export default function ({
    filter,
    systems,
    itemSelected,
    preloaded,
    cardItemLinksDisabled,
}) {
    const [_filter, setFilter] = useState(filter);
    const [_filter2, setFilter2] = useState(filter);
    const [_systems, setSystems] = useState(systems);
    const [_page, setPage] = useState({
        current_page: 1,
        last_page: systems ? systems.last_page : 1,
    });

    const [text, setText] = useState("");
    const [debouncedText, setDebouncedText] = useState("");

    const [, cancel] = useDebounce(
        () => {
            setDebouncedText(text);
        },
        300,
        [text]
    );

    const updateData = async (data, current_page) => {
        setPage({ current_page, last_page: data.systems.last_page });
        setSystems(data.systems);
        setFilter2(data.filter);
    };

    const [catalog, fetchCatalog] = useAsyncFn(
        async (filter, debouncedText, current_page) => {
            console.log("SystemsCatalog: fetchCatalog!");

            const response = await axios.post("catalog", {
                filter: {
                    ...filter,
                    query_s: debouncedText,
                },
                region,
                direction,
                page: current_page,
            });

            updateData(response.data, current_page);

            return response.data;
        },
        []
    );

    const updateFilter = () => {
        setFilter((state) => {
            return { ...state, ..._filter2 };
        });
    };

    useEffect(() => {
        console.log("SystemsCatalog: componentDidMount!");
        if (systems && systems.data.length) return;
        fetchCatalog(_filter, debouncedText, _page.current_page);
    }, []);

    useUpdateEffect(() => {
        console.log("SystemsCatalog: componentDidUpdate!");
        fetchCatalog(_filter, debouncedText, _page.current_page);
        window.scrollTo({ top: 0 });
    }, [_filter, debouncedText, _page.current_page]);

    if (_systems && _filter2) {
        return (
            <div className="row">
                <div
                    className="d-none d-lg-block col-4 col-xl-3"
                    id="catalog-filter"
                >
                    <div className="offcanvas-header d-lg-none">
                        <h5 className="offcanvas-title">Фильтр</h5>
                        <button
                            type="button"
                            className="btn-close text-reset"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="offcanvas-body">
                        <FilterComponent
                            filter={_filter2}
                            updateFilter={() => updateFilter()}
                        />
                    </div>
                </div>
                <div className="col-12 col-lg-8 col-xl-9">
                    <CatalogToolBar
                        filter={_filter2}
                        text={text}
                        setText={setText}
                    />
                    <FilterTags
                        filter={_filter2}
                        updateFilter={() => updateFilter()}
                    />
                    <CatalogContent
                        items={_systems.data}
                        itemSelected={(item) => itemSelected(item)}
                        cardItemLinksDisabled={cardItemLinksDisabled}
                        isLoading={catalog.loading}
                    />
                    {_page.last_page > 1 && (
                        <Paginator
                            page={_page}
                            setPage={(page) =>
                                setPage({ ..._page, current_page: page })
                            }
                        />
                    )}
                </div>
            </div>
        );
    }

    return <div className="i-icon-loader"></div>;
}
